import React from 'react'

// Custom hook, preserves values in sessionStorage until refresh
// Inspiration: https://www.joshwcomeau.com/snippets/react-hooks/use-sticky-state/
export const useStickyState = (defaultValue: string, key: string) => {
  const [value, setValue] = React.useState(() => {
    const stickyValue = globalThis.sessionStorage.getItem(key)
    return stickyValue === null ? defaultValue : JSON.parse(stickyValue)
  })
  React.useEffect(() => {
    globalThis.sessionStorage.setItem(key, JSON.stringify(value))
  }, [key, value])
  return [value, setValue]
}

export const removeSessionStorageItem = (key: string) => {
  sessionStorage.removeItem(key)
}
